import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Configuration } from '@app/models/config.model';
import { HubConnectionState } from '@app/+state/signalR/hub-connection-state';
import { HttpMethod, SignalRFacade, UiStateFacade } from '@ra-state';
import { ConfigService } from '@rockwell-automation-inc/service';
import { EMPTY, Observable, mergeMap, of, tap } from 'rxjs';

@Injectable()
export class SignalRConnectionInterceptor implements HttpInterceptor {
  private readonly uiStateFacade = inject(UiStateFacade);
  private readonly configService = inject<ConfigService<Configuration>>(ConfigService);
  private readonly signalRFacade = inject(SignalRFacade);

  connectionState: HubConnectionState | undefined;

  // this is one time subscription, we cann't call inside intrecept, as intercept will be called multiple times
  signalRConnectionSub = this.signalRFacade.connectionState$
    .pipe(
      tap((connectionState) => {
        this.connectionState = connectionState;
      }),
    )
    .subscribe();

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return of(null).pipe(
      mergeMap(() => {
        const csApiRequest = this.configService.config.isApiCall(request.url);
        const isConnected = this.connectionState === HubConnectionState.Connected;
        const isGet = request.method === HttpMethod.GET;

        // Allow non-CS API calls (shor-circuit)
        // else check If CS API call then check signalR connected, allow if connected
        // else check if signalR not connected allow only get calls
        if (!csApiRequest || isConnected || isGet) {
          return next.handle(request);
        }

        // Block CS API requests that are not GET when the signalR connection is not connected
        this.uiStateFacade.displayMessage({
          message: `We are having some internal issues. The portal is currently in read-only mode. Please try again later.`,
          type: 'Error',
        });

        return EMPTY;
      }),
    );
  }
}
